module.exports = __webpack_public_path__ + "static/media/gal0508.cf4c3b5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal05/gal0508.jpg
// module id = 466
// module chunks = 0